import styled from 'styled-components'

const SidebarDivider = styled.hr`
	background-color: rgba(9,30,66,.13);
	border: 0;
	height: 1px;
	margin: 16px 0;
	padding: 0;
	width: 100%;
`

export default SidebarDivider